// Imports
import ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ from "../../../../node_modules/html-loader/dist/runtime/getUrl.js";
var ___HTML_LOADER_IMPORT_0___ = new URL("../../../assets/spinner.gif", import.meta.url);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"spinner-component\"> <div class=\"spinner-wrapper\"> <img class=\"loading-icon\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"/> </div> </div> ";
// Exports
export default code;